import type { ParagraphType, Audience } from '../../interfaces';
import { parseTestDate } from './timeUtils';

const createFilterContentSnippetsForCurrentTime = ({ testDate }: { testDate?: string | null }) => {
  const date = parseTestDate({ testDate }) || new Date();
  return (item: any): boolean => {
    // check if current content snippets are in the given time range
    // eslint-disable-next-line @typescript-eslint/naming-convention
    const { field_visible_from, field_visible_until, field_valid_from, field_valid_to } = item;

    const dateNowFinal = date.getTime();
    const fromDate = field_visible_from || field_valid_from;
    const untilDate = field_visible_until || field_valid_to;

    const validFromDate = new Date(fromDate);
    const validFromDateFinal = validFromDate.getTime();

    const validUntilDate = new Date(untilDate);
    const validUntilDateFinal = validUntilDate.getTime();

    // check if current content snippets are in the given time range
    if (fromDate || untilDate) {
      if (fromDate && untilDate) {
        if (dateNowFinal > validFromDateFinal && dateNowFinal < validUntilDateFinal) {
          return true;
        }
      } else if (fromDate && !untilDate) {
        if (dateNowFinal > validFromDateFinal) {
          return true;
        }
      } else if (untilDate && !fromDate) {
        if (dateNowFinal < validUntilDateFinal) {
          return true;
        }
      }
      return false;
    }

    return true;
  };
};

const createFilterForCurrentAudiences =
  (audiences: Audience[]) =>
  (item: ParagraphType): boolean => {
    if ('taxonomy_term' in item && Array.isArray(item.taxonomy_term)) {
      const taxonomyTerms = item.taxonomy_term;
      // if we find a taxonomy_term with the name that is in audiences, we return true
      return taxonomyTerms.some(
        (t) => t.field_name === 'field_audience' && audiences.includes(t.name),
      );
    }
    // if there is no taxonomy_term at all, we always want to display it and return true
    return true;
  };

export { createFilterContentSnippetsForCurrentTime, createFilterForCurrentAudiences };
